import React, { useState, useEffect } from 'react';
import { HeroWrapper, HeroDiv } from './MovieHeroStyles';
import VideoPlayer from '../VideoPlayer';
import Toast from '../Toast';
import { imageUrl, backdropSize } from '../api';
import { useGlobalContext } from '../../Context';
import addBtn from '../../imgs/svgs/addBtn.svg';

const MovieHero = ({ movieData, isLoading }) => {
  const [hasTrailer, setHasTrailer] = useState(false);
  const [bool, setBool] = useState(false);

  const { addToList, showToast } = useGlobalContext();

  const playTrailer = () => {
    setBool(true);
  };

  // set fall back for no image
  const bgImage = movieData.backdrop
    ? `${imageUrl}${backdropSize.l}/${movieData.backdrop}`
    : `${imageUrl}${backdropSize.l}/${movieData.poster_path}`;

  useEffect(() => {
    if (movieData.trailer) {
      setHasTrailer(() => true);
    } else {
      setHasTrailer(() => false);
    }
  }, [movieData.trailer, setHasTrailer]);

  return (
    <>
      <HeroWrapper>
        <HeroDiv
          bg={bgImage}
          hasTrailer={hasTrailer}
          hasBg={movieData.backdrop}
        >
          <div
            className='img-wrapper'
            onClick={() => {
              if (hasTrailer) {
                playTrailer();
              } else {
                return;
              }
            }}
          >
            <img
              className='vid-thumb'
              src={`${imageUrl}${backdropSize.s}/${movieData.poster_path}`}
              alt={movieData.title}
            />
          </div>

          <div className='movie-info'>
            <div className='rating'>
              <span>{Math.round(movieData.vote_average * 10)}%</span>
            </div>
            <h1>{movieData.title}</h1>
            <p>{movieData.overview}</p>
            <div className='btns'>
              <button className='btn'>WATCH NOW</button>
              <button
                onClick={() => addToList(movieData.id)}
                className='addBtnLg'
              >
                <span className='round'>
                  <img src={addBtn} alt='Add to my list' />
                </span>
                Add to watch list
              </button>
            </div>
          </div>
        </HeroDiv>
      </HeroWrapper>

      {bool && <VideoPlayer video={movieData.trailer} setBool={setBool} />}

      {showToast.isShowing && (
        <Toast heading={showToast.heading} message={showToast.msg} />
      )}
    </>
  );
};

export default MovieHero;
